import React from 'react';
import { func } from 'prop-types';

import { Container } from '@ajaibid/components';

import { useStockBuySellContext } from '../../../hooks';
import InputPrice from './InputPrice';
import InputLotCount from './InputLotCount';
import InputBtnPercentage from './InputBtnPercentage';
import SummaryBuyingPower from './SummaryBuyingPower';
import SummaryAvailableLot from './SummaryAvailableLot';
import SummaryTotal from './SummaryTotal';
import DayTradingInfo from './DayTradingInfo';

const FormLimitOrder = (props) => {
  const { onClickAvailableLotInfo, onSubmit } = props;

  const { isBuy, isSell } = useStockBuySellContext();

  return (
    <Container padding={0}>
      <InputPrice marginTop={20} onSubmit={onSubmit} />
      <InputLotCount marginTop={12} onSubmit={onSubmit} />
      <InputBtnPercentage marginTop={8} marginBottom={16} />
      {isBuy && <SummaryBuyingPower />}
      {isSell && <SummaryAvailableLot onClickAvailableLotInfo={onClickAvailableLotInfo} />}
      <SummaryTotal marginTop={12} />
      <DayTradingInfo />
    </Container>
  );
};

FormLimitOrder.propTypes = {
  onClickAvailableLotInfo: func,
  onSubmit: func,
};

FormLimitOrder.defaultProps = {
  onClickAvailableLotInfo: () => {},
  onSubmit: () => {},
};

export default FormLimitOrder;
